/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by Omnia
 * On: 13/Oct/2026.
 */

package com.narbase.letsgo.web.views.ridepromocode
import com.narbase.kunafa.core.lifecycle.Observable
import com.narbase.letsgo.web.dto.ridepromocode.AdminRidePromoCodeDto
import com.narbase.letsgo.web.dto.ridepromocode.ExtendedRidePromoCodeDto
import com.narbase.letsgo.web.network.InvalidRequestException
import com.narbase.letsgo.web.network.basicNetworkCall
import com.narbase.letsgo.web.network.remoteProcess
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.GetRidePromoCodesEndpoint
import com.narbase.letsgo.web.routing.domain.admin.ridepromocodes.UpsertRidePromoCodeEndpoint
import com.narbase.letsgo.web.utils.BasicUiState
import com.narbase.letsgo.web.utils.DataResponse.Companion.BASIC_SUCCESS

class RidePromoCodesManagementViewModel {

    val getUiState = Observable<BasicUiState>()
    val upsertUiState = Observable<BasicUiState>()
    val autoAssignUiState = Observable<BasicUiState>()
    val responseErrorMessage = Observable<String?>()


    var promoCodes: Array<ExtendedRidePromoCodeDto> = arrayOf()
    /** Promo codes that would be auto-assigned right now: used for the dialog warning. */
    var activeAutoAssign: Array<ExtendedRidePromoCodeDto> = arrayOf()

    var pageNo = 0
    var pageSize = 20
    var searchTerm = ""
    var total = 0

    fun getList() {
        setUpsertUiStateToNull()
        basicNetworkCall(getUiState) {
            val dto = GetRidePromoCodesEndpoint.Request(pageNo, pageSize, searchTerm, null)
            val response = GetRidePromoCodesEndpoint.remoteProcess(dto).data
            promoCodes = response.list
            total = response.total
        }
    }

    fun getActiveAutoAssign() {
        basicNetworkCall(autoAssignUiState) {
            val dto = GetRidePromoCodesEndpoint.Request(0, 100, "", true)
            activeAutoAssign = GetRidePromoCodesEndpoint.remoteProcess(dto).data.list
        }
    }

    fun searchFor(term: String) {
        pageNo = 0
        searchTerm = term
        getUiState.value = BasicUiState.Loaded
        getList()
    }

    fun upsert(dto: AdminRidePromoCodeDto, onError: (String) -> Unit) {
        basicNetworkCall(upsertUiState) {
            val response = UpsertRidePromoCodeEndpoint.remoteProcess(UpsertRidePromoCodeEndpoint.Request(dto))
            if (response.status != "$BASIC_SUCCESS") {
                onError( "Invalid input. Verify and try again.")
                throw InvalidRequestException()
            }
        }
    }

    fun getNextPage() { pageNo++; getList() }
    fun getPreviousPage() { pageNo--; getList() }
    fun setUpsertUiStateToNull() { upsertUiState.value = null }
}